// calculations.js - Utility functions for invoice calculations.
export const calculateTotals = (items, taxRate, discountRate) => {
    let subTotalValue = 0;
    items.forEach(item => {
      subTotalValue += parseFloat(item.price) * parseInt(item.quantity);
    });
    subTotalValue = parseFloat(subTotalValue).toFixed(2);
    const taxAmountValue = parseFloat(subTotalValue * (taxRate / 100)).toFixed(2);
    const discountAmountValue = parseFloat(subTotalValue * (discountRate / 100)).toFixed(2);
    const totalValue = (parseFloat(subTotalValue) - parseFloat(discountAmountValue) + parseFloat(taxAmountValue)).toFixed(2);
    return { subTotalValue, taxAmountValue, discountAmountValue, totalValue };
  };